<template>
  <div>
    <b-modal
      ref="chatDelete"
      :title="$t('messages.deleteChat')"
      size="sm"
      dialog-class="message-info-modal"
      hide-footer
      hide-backdrop
      v-if="windowWidth < 800"
      >
      <div style="text-align: center;">
        {{ $t('messages.deleteChatQuestion') }} {{ sessionSelectionDelete.split(':').toString() }}?
        <b-button class="mt-2" variant="outline-secondary" block @click="cancelDeleteChat">{{ $t('messages.cancel') }}</b-button>
        <b-button class="mt-2" variant="danger" block @click="deleteChat">{{ $t('messages.delete') }}</b-button>
      </div>
    </b-modal>
    <b-modal
      ref="chatDelete"
      :title="$t('messages.deleteChat')"
      size="sm"
      hide-footer
      hide-backdrop
      v-else
      >
      <div style="text-align: center;">
        {{ $t('messages.deleteChatQuestion') }} {{ sessionSelectionDelete.split(':').toString() }}?
        <b-button class="mt-2" variant="outline-secondary" block @click="cancelDeleteChat">{{ $t('messages.cancel') }}</b-button>
        <b-button class="mt-2" variant="danger" block @click="deleteChat">{{ $t('messages.delete') }}</b-button>
      </div>
    </b-modal>
    <div class="messages-row" style="padding: 5px auto; margin-bottom: 0 !important; margin-top: 0 !important; background-color: #F7F7F7;">
      <i class="mdi mdi-message" aria-hidden="true"></i>&nbsp;{{ $t('messages.messages') }}
    </div>
    <div class="messages-row row" style="padding: 20px auto; margin-bottom: 0 !important; margin-top: 0 !important;" v-if="selectedSession.length <= 0">
      <b-input-group>
        <b-form-input style="border-right: 0;" v-model="search" @keyup="performSearch" size="sm" :placeholder="$t('messages.to')">
        </b-form-input>
        <b-input-group-prepend>
          <span class="input-group-text clickable" style="padding: .1rem .75rem !important;" @click="addChat"><i class="mdi mdi-square-edit-outline" aria-hidden="true"></i></span>
        </b-input-group-prepend>
      </b-input-group>
    </div>
    <div style="height: 488px; width: 240px; overflow-y: scroll; text-align: center; background-color: #FFFFFF;" v-if="selectedSession.length <= 0 && chatConnected">
      <div class="messages-row chat-list" style="margin: 0px auto !important;">
        <div class="inbox_chat" v-if="searchedSessions">
          <div class="chat_list" v-for="(item,i) in searchedSessions" @mousedown="sessionMousedown(item)" @mouseup="sessionMouseup(item)" :key="`searchID${i}`">
            <div class="chat_people">
              <div class="chat_img"> <img src="https://www.gravatar.com/avatar/?d=mp" style="width: 32px;" alt="Photo"> </div>
              <div class="chat_ib">
                <h5 v-if="item.split(':').length > 1"><text-highlight :queries="queries" :highlightStyle="highlightStyle">{{ contactObject[item.split(':')[0]] || item.split(':')[0] }},{{ contactObject[item.split(':')[1]] ? contactObject[item.split(':')[1]].substring(0, 3) : null || item.split(':')[1].substring(0, 3) }}...</text-highlight> <span class="chat_ib_span">{{ (messages[item] ? messages[item][messages[item].length - 1].time : '') | formatDate(today, yesterday) }}</span></h5>
                <h5 v-else><text-highlight :queries="queries" :highlightStyle="highlightStyle">{{ contactObject[item] || item }}</text-highlight> <span class="chat_ib_span">{{ (messages[item] ? messages[item][messages[item].length - 1].time : '') | formatDate(today, yesterday) }}</span></h5>
                <p v-if="messages[item]">
                  <span v-if="messages[item][messages[item].length - 1].media">
                    <i class="mdi mdi-attachment" aria-hidden="true"></i>&nbsp;media
                  </span>
                  <span v-else>
                    <text-highlight :queries="queries" :highlightStyle="highlightStyle">{{ messages[item][messages[item].length - 1].msg.length > 25 ? messages[item][messages[item].length - 1].msg.substring(0, 25) : messages[item][messages[item].length - 1].msg }}</text-highlight>
                  </span>
                  <b-badge pill variant="primary" v-if="messages[item] ? !messages[item][messages[item].length - 1].read : false">New</b-badge>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="inbox_chat" v-else>
          <div class="chat_list" v-for="(item,i) in sortedSessions" @mousedown="sessionMousedown(item)" @mouseup="sessionMouseup(item)" :key="`sortID${i}`">
            <div class="chat_people">
              <div class="chat_img"> <img src="https://www.gravatar.com/avatar/?d=mp" style="width: 32px;" alt="Photo"> </div>
              <div class="chat_ib">
                <h5 v-if="item.split(':').length > 1">{{ contactObject[item.split(':')[0]] || item.split(':')[0] }},{{ contactObject[item.split(':')[1]] ? contactObject[item.split(':')[1]].substring(0, 3) : null || item.split(':')[1].substring(0, 3) }}...<span class="chat_ib_span">{{ (messages[item] ? messages[item][messages[item].length - 1].time : '') | formatDate(today, yesterday) }}</span></h5>
                <h5 v-else>{{ contactObject[item] || item }} <span class="chat_ib_span">{{ (messages[item] ? messages[item][messages[item].length - 1].time : '') | formatDate(today, yesterday) }}</span></h5>
                <p v-if="messages[item]">
                  <span v-if="messages[item][messages[item].length - 1].media">
                    <i class="mdi mdi-attachment" aria-hidden="true"></i>&nbsp;media
                  </span>
                  <span v-else>
                    <text-highlight :queries="queries" :highlightStyle="highlightStyle">{{ messages[item][messages[item].length - 1].msg.length > 25 ? messages[item][messages[item].length - 1].msg.substring(0, 25) : messages[item][messages[item].length - 1].msg }}</text-highlight>
                  </span>
                  <b-badge pill variant="primary" v-if="messages[item] ? !messages[item][messages[item].length - 1].read : false">New</b-badge>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="messages-row row" style="padding: 20px auto; margin-bottom: 0 !important; margin-top: 0 !important; background-color: rgb(249, 249, 249);" v-if="selectedSession.length > 0 && chatConnected">
      <div class="col-sm-2">
        <i class="mdi mdi-arrow-left clickable" aria-hidden="true" @click="clearSession"></i>
      </div>
      <div class="col-sm-8">
        <span v-if="selectedSession.split(':').length <= 1">
          <span v-if="contactObject[selectedSession]">
            <span style="font-size: 0.8rem;">{{ contactObject[selectedSession] }}</span>
            <p style="font-size: 0.2rem; margin: 0 auto;">{{ selectedSession }}</p>
          </span>
          <span style="display: inline-block; height: 36px;" v-else>
            {{ selectedSession }}
          </span>
        </span>
        <span v-else>
          <span style="font-size: 0.8rem;">
            {{ contactObject[selectedSession.split(':')[0]] || selectedSession.split(':')[0] }}, {{ contactObject[selectedSession.split(':')[1]] ? contactObject[selectedSession.split(':')[1]].substring(0, 3) : selectedSession.split(':')[1].substring(0, 3) }}...
          </span>
          <p style="font-size: 0.2rem; margin: 0 auto;">
            {{ selectedSession.split(':')[0] }}, {{ selectedSession.split(':')[1].substring(0, 3) }}...
          </p>
        </span>
      </div>
      <div class="col-sm-2">
        <b-dropdown size="md" variant="link" toggle-class="text-decoration-none menu-toggle" :no-caret="true">
          <template slot="button-content">
            <i class="mdi mdi-dots-vertical" aria-hidden="true"></i>
          </template>
          <b-dropdown-item href="#" @click="getMessageInfo" v-if="selectedSession.split(':').length > 1">{{ $t('messages.groupInfo') }}</b-dropdown-item>
          <b-dropdown-item href="#" @click="deleteEntireHistory()">{{ $t('messages.deleteChat') }}</b-dropdown-item>
        </b-dropdown>
      </div>
      <b-modal
        ref="entireChatDelete"
        :title="$t('messages.deleteChat')"
        size="sm"
        dialog-class="message-info-modal"
        hide-footer
        hide-backdrop
        v-if="windowWidth < 800"
        >
        <div style="text-align: center;">
          {{ $t('messages.deleteChatQuestion') }} {{ sessionSelectionDelete.split(':').toString() }}?
          <b-button class="mt-2" variant="outline-secondary" block @click="cancelDeleteEntireChat">{{ $t('messages.cancel') }}</b-button>
          <b-button class="mt-2" variant="danger" block @click="deleteChat">{{ $t('messages.delete') }}</b-button>
        </div>
      </b-modal>
      <b-modal
        ref="entireChatDelete"
        :title="$t('messages.deleteChat')"
        size="sm"
        hide-footer
        hide-backdrop
        v-else
        >
        <div style="text-align: center;">
          {{ $t('messages.deleteChatQuestion') }} {{ sessionSelectionDelete.split(':').toString() }}?
          <b-button class="mt-2" variant="outline-secondary" block @click="cancelDeleteEntireChat">{{ $t('messages.cancel') }}</b-button>
          <b-button class="mt-2" variant="danger" block @click="deleteChat">{{ $t('messages.delete') }}</b-button>
        </div>
      </b-modal>
      <b-modal
        ref="messageInfo"
        :title="$t('messages.groupInfo')"
        :scrollable="true"
        size="sm"
        dialog-class="message-info-modal"
        hide-footer
        hide-backdrop
        v-if="windowWidth < 800"
        >
        <div style="text-align: center; font-size: 0.9rem;">
          <span v-for="(ss,i) in selectedSession.split(':')" :key="`messageInfoID${i}`">
            <p>{{ contactObject[ss] ? `${contactObject[ss]}(${ss})` : ss }}</p>
          </span>
        </div>
      </b-modal>
      <b-modal
        ref="messageInfo"
        :title="$t('messages.groupInfo')"
        :scrollable="true"
        size="sm"
        hide-footer
        hide-backdrop
        v-else
        >
        <div style="text-align: center; font-size: 0.9rem;">
          <span v-for="(ss,i) in selectedSession.split(':')" :key="`messageInfoID${i}`">
            <p>{{ contactObject[ss] ? `${contactObject[ss]}(${ss})` : ss }}</p>
          </span>
        </div>
      </b-modal>
    </div>
    <div v-chat-scroll="{always: false, smooth: true, notSmoothOnInit: true}" style="height: 406px; width: 240px; overflow-y: scroll; background-color: #FFFFFF;" v-if="selectedSession.length > 0 && chatConnected">
      <b-list-group>
        <b-list-group-item v-for="message in messages[selectedSession]" :class="message.direction === 'IN' ? 'inbox_item_left' : 'inbox_item_right'">
          <div class="message container" v-if="message.direction === 'IN'">
            <p style="font-size: 0.8rem;" v-if="message.msg">{{ message.msg }}</p>
            <p class="attachment" v-if="message.media">
              <img class="attachment" :src="message.media" :alt="$t('messages.mediaExpired')" />
              <a :href="message.media" target="_blank" download>
                <i class="mdi mdi-download" :v-tooltip="$t('messages.mediaExpiresAfter')" aria-hidden="true"></i>
              </a>
            </p>
            <span style="font-size: 0.5rem;" class="time-left">{{ message.time | formatTime(today, yesterday) }}</span>
          </div>
          <div class="message container darker" v-else>
            <p style="font-size: 0.8rem;" v-if="message.msg">{{ message.msg }}</p>
            <p class="attachment" v-if="message.media">
              <img class="attachment" :src="message.media" :alt="$t('messages.mediaExpired')" />
              <a style="color: white;" :href="message.media" target="_blank" download>
                <i class="mdi mdi-download" :v-tooltip="$t('messages.mediaExpiresAfter')" aria-hidden="true"></i>
              </a>
            </p>
            <span style="font-size: 0.5rem;" class="time-right">{{ message.time | formatTime(today, yesterday) }}</span>
          </div>
        </b-list-group-item>
      </b-list-group>
    </div>
    <div class="chat-row" v-if="selectedSession.length > 0 && chatConnected">
      <span v-if="attachment" style="margin-left: 5px;">{{ attachment.name }}<i class="mdi mdi-close-box clickable" aria-hidden="true" @click="clearAttachment"></i></span>
      <b-input-group>
        <b-form-textarea
          id="sendMessage"
          v-model="sendMessage"
          :placeholder="$t('messages.textMessage')"
          rows="2"
          max-rows="2"
          no-resize
          v-if="attachment"
        ></b-form-textarea>
        <b-form-textarea
          id="sendMessage"
          v-model="sendMessage"
          :placeholder="$t('messages.textMessage')"
          rows="3"
          max-rows="3"
          no-resize
          v-else
        ></b-form-textarea>
        <b-input-group-prepend>
          <span class="input-group-text" style="padding: .1rem .25rem !important;" v-if="sendProcessing"><b-spinner variant="teal" label="Spinning"></b-spinner></span>
          <span class="input-group-text clickable" style="padding: .1rem .75rem !important;" @click="addAttachment" v-if="!sendProcessing">
            <i class="mdi mdi-attachment" aria-hidden="true"></i>
          </span>
          <span class="input-group-text clickable" style="padding: .1rem .75rem !important;" @click="send" v-if="!sendProcessing"><i class="mdi mdi-send" aria-hidden="true"></i></span>
          <div class="hidden"><b-form-file id="fileUploader" v-model="attachment"></b-form-file></div>
        </b-input-group-prepend>
      </b-input-group>
    </div>
    <div v-if="!chatConnected">
      <br /><br /><br />
      {{ $t('messages.chatDisconnected') }}<br />
      {{ $t('messages.refreshPage') }}
    </div>
  </div>
</template>

<script>
import Axios from 'axios'
import VueChatScroll from 'vue-chat-scroll'
import Moment from 'moment-timezone'
import TextHighlight from 'vue-text-highlight'
// import VueSocketIO from 'vue-socket.io'

export default {
  name: 'Messages',
  components: {
    'v-chat-scroll': VueChatScroll,
    'text-highlight': TextHighlight
  },
  mounted: async function () {
    var self = this

    var today = new Date().toLocaleString("en-US", {timeZone: "America/New_York"})
    today = today.split(',')[0]

    self.today = `${today.split('/')[1].length === 1 ? '0' + today.split('/')[1] : today.split('/')[1]} ${today.split('/')[0].length === 1 ? '0' + today.split('/')[0] : today.split('/')[0]} ${today.split('/')[2]}`

    today = new Date()
    var yesterday = new Date(today)
    yesterday.setDate(today.getDate() - 1)
    yesterday = yesterday.toLocaleString("en-US", {timeZone: "America/New_York"})
    yesterday = yesterday.split(',')[0]

    self.yesterday = `${yesterday.split('/')[1].length === 1 ? '0' + yesterday.split('/')[1] : yesterday.split('/')[1]} ${yesterday.split('/')[0].length === 1 ? '0' + yesterday.split('/')[0] : yesterday.split('/')[0]} ${yesterday.split('/')[2]}`

    try {
      self.device = localStorage.getItem('device')
      const response = await Axios.get(`${process.env.FONESTORM_API}/devices/${self.device}/verto`, { headers: { token: localStorage.getItem('fonestorm-token') } })
      self.fonenumber = response.data.device.fonenumber
    } catch (error) {
      if (error && error.response && error.response.status === 401) {
        self.$router.push({ name: 'Login' })
      }
    }

    if (localStorage.getItem(`message-sessions-${self.device}`)) {
      self.sessions = localStorage.getItem(`message-sessions-${self.device}`).split(',')
    }
    if (localStorage.getItem(`messages-${self.device}`)) {
      self.messages = JSON.parse(localStorage.getItem(`messages-${self.device}`))
    }
  },
  computed: {
    sortedSessions: function () {
      var self = this
      var data = self.sessions.sort(function (a, b) {
        var c = self.messages[a][self.messages[a].length - 1].time
        var d = self.messages[b][self.messages[b].length - 1].time
        return (c === d ? 0 : c > d ? -1 : 1)
      })
      return data
    }
  },
  props: {
    contactObject: {
      type: Object
    },
    chatConnected: {
      type: Boolean
    }
  },
  data () {
    return {
      fonenumber: '',
      isConnected: false,
      selectedSession: '',
      chatting: true,
      sendMessage: '',
      sessions: [],
      sessionSelectionProcess: false,
      sessionSelectionDelete: '',
      searchedSessions: null,
      messages: {},
      device: null,
      sendProcessing: false,
      today: '',
      yesterday: '',
      attachment: null,
      search: '',
      queries: [],
      highlightStyle: { 'background-color': 'white', color: '#167bff', 'font-size': '1.15rem', 'float': '' },
      windowWidth: window.innerWidth
    }
  },
  methods: {
    selectSession (number) {
      var self = this
      self.selectedSession = number

      // Mark all read
      var messages = []
      self.messages[number].forEach((message) => {
        message.read = true
        messages.push(message)
      })

      self.messages[number] = messages

      localStorage.setItem(`messages-${self.device}`, JSON.stringify(self.messages))
    },
    sessionMousedown (number) {
      var self = this
      self.sessionSelectionProcess = true
      setTimeout(() => {
        if (self.sessionSelectionProcess) {
          self.sessionSelectionDelete = number
          self.sessionSelectionProcess = false
          self.$refs['chatDelete'].show()
        }
      }, 1000)
    },
    sessionMouseup (number) {
      var self = this
      if (self.sessionSelectionProcess) {
        self.selectSession(number)
        self.sessionSelectionProcess = false
      }
    },
    deleteChat () {
      var self = this
      if (self.sessionSelectionDelete.length > 0) {
        if (self.messages[self.sessionSelectionDelete]) {
          delete self.messages[self.sessionSelectionDelete];
        }
        if (self.sessions.indexOf(self.sessionSelectionDelete) > -1) {
          self.sessions.splice(self.sessions.indexOf(self.sessionSelectionDelete), 1);
        }
      }
      localStorage.setItem(`messages-${self.device}`, JSON.stringify(self.messages))
      localStorage.setItem(`message-sessions-${self.device}`, self.sessions)
      self.sessionSelectionDelete = ''
      self.selectedSession = ''
      self.$refs['chatDelete'].hide()
      self.$refs['entireChatDelete'].hide()
    },
    cancelDeleteChat () {
      var self = this
      self.sessionSelectionDelete = ''
      self.$refs['chatDelete'].hide()
    },
    deleteEntireHistory () {
      var self = this
      self.sessionSelectionDelete = self.selectedSession
      self.sessionSelectionProcess = false
      self.$refs['entireChatDelete'].show()
    },
    cancelDeleteEntireChat () {
      var self = this
      self.sessionSelectionDelete = ''
      self.$refs['entireChatDelete'].hide()
    },
    clearSession () {
      var self = this
      if (self.messages[self.selectedSession].length < 1) {
        self.sessions.pop()
      }
      self.selectedSession = ''
    },
    send: async function () {
      var self = this
      self.sendProcessing = true
      const payload = {
        fonenumber: self.fonenumber,
        to: self.selectedSession.split(':'),
        message: self.sendMessage
      }
      if (self.sendMessage.length > 0 || self.attachment) {
        try {
          if (self.attachment) {
            // Add to form data
            const form_data = new FormData()
            form_data.append('fonenumber', payload.fonenumber)
            form_data.append('to', payload.to)
            if (payload.message.length > 0) {
              form_data.append('message', payload.message)
            }
            form_data.append('media', self.attachment)
            await Axios.post(`${process.env.FONESTORM_API}/messages/send`, form_data, { headers: { 'Content-Type': 'multipart/form-data', token: localStorage.getItem('fonestorm-token') } })
            const data = new FormData()
            data.append('file', self.attachment)
            const fonestormFile = await Axios.post(`${process.env.FONESTORM_API}/documents/verto`, data, { headers: { 'Content-Type': 'multipart/form-data', token: localStorage.getItem('fonestorm-token') } })
            const attachment = `${process.env.FONESTORM_API}${fonestormFile.data.document.url}/${fonestormFile.data.document.file_name}`
            // const attachment = fonestormFile.data.document.cloud_url
            const today = Moment.utc().tz('America/New_York')
            self.messages[self.selectedSession].push({
              to: self.selectedSession,
              from: self.fonenumber,
              msg: self.sendMessage,
              media: attachment,
              direction: 'OUT',
              time: today.format(),
              read: true
            })
            self.sendMessage = ''
            self.attachment = null
            localStorage.setItem(`messages-${self.device}`, JSON.stringify(self.messages))
            localStorage.setItem(`message-sessions-${self.device}`, self.sessions)
          } else {
            await Axios.post(`${process.env.FONESTORM_API}/messages/send`, payload, { headers: { token: localStorage.getItem('fonestorm-token') } })
            const today = Moment.utc().tz('America/New_York')
            self.messages[self.selectedSession].push({
              to: self.selectedSession,
              from: self.fonenumber,
              msg: self.sendMessage,
              media: null,
              direction: 'OUT',
              time: today.format(),
              read: true
            })
            self.sendMessage = ''
            localStorage.setItem(`messages-${self.device}`, JSON.stringify(self.messages))
            localStorage.setItem(`message-sessions-${self.device}`, self.sessions)
          }
        } catch (error) {
          if (error && error.response && error.response.status === 401) {
            self.$router.push({ name: 'Login' })
          }
        }
        self.sendProcessing = false
      }
    },
    addChat () {
      var self = this
      if (self.search.length > 0) {
        let valid = true
        self.search = self.search.split(',').map((s) => s.replace(/\D/g,''))
        self.search = self.search.join(',')
        self.search.split(',').forEach((search) => {
          if (isNaN(search)) {
            valid = false
          }
        })
        if (valid) {
          if (self.search.split(',').length > 1) {
            self.search = self.search.replace(/\s/g,'').split(',').sort().join(':')
          }
          if (self.sessions.indexOf(self.search) > -1) {
            self.selectedSession = self.search
          } else {
            self.sessions.push(self.search)
            self.messages[self.search] = []
            self.selectedSession = self.search
          }
          self.search = self.search.split(':').toString()
        }
      }
    },
    addChatExternally (number) {
      var self = this
      setTimeout (() => {
        if (self.sessions.indexOf(number) > -1) {
          self.selectedSession = number
        } else {
          self.sessions.push(number)
          self.messages[number] = []
          self.selectedSession = number
        }
      }, 1000)
    },
    addAttachment () {
      document.getElementById('fileUploader').click()
    },
    clearAttachment () {
      this.attachment = null
    },
    refreshChat () {
      var self = this
      if (localStorage.getItem(`message-sessions-${self.device}`)) {
        self.sessions = localStorage.getItem(`message-sessions-${self.device}`).split(',')
      }
      if (localStorage.getItem(`messages-${self.device}`)) {
        self.messages = JSON.parse(localStorage.getItem(`messages-${self.device}`))
      }
    },
    performSearch () {
      var self = this
      if (self.search.length <= 0) {
        self.searchedSessions = null
        self.queries = []
      } else {
        var tempSessions = []
        self.queries = []

        self.sortedSessions.forEach ((session) => {
          if (session.indexOf(self.search.toLowerCase()) != -1 || (self.contactObject[session] && self.contactObject[session].toLowerCase().indexOf(self.search.toLowerCase()) != -1)) {
            tempSessions.push(session)
          } else {
            var found = false
            self.messages[session].forEach((message) => {
              if (message.msg && message.msg.toLowerCase().indexOf(self.search.toLowerCase()) != -1 && !found) {
                tempSessions.push(session)
                found = true
              }
            })
          }
        })

        self.searchedSessions = tempSessions
        self.queries.push(self.search)
      }
    },
    clearSearch () {
      var self = this
      self.searchedSessions = null
      self.queries = []
      self.search = ''
    },
    getMessageInfo () {
      this.$refs['messageInfo'].show()
    }
  }
}

</script>

<style>
.messages-row {
  margin: 20px auto !important;
  width: auto;
  max-width: 420px !important;
  height: auto !important;
  clear: both !important;
  text-align: center !important;
}

.clickable:hover {
  cursor: pointer;
}

.chat-row {
  margin: 0 auto !important;
  width: auto;
  max-width: 420px !important;
  height: auto !important;
  clear: both !important;
  text-align: left !important;
}

.chat-list:hover {
  cursor: pointer;
}

/* Chat containers */
.container {
  border: 2px solid #dedede;
  background-color: #f1f1f1;
  border-radius: 5px;
  padding: 10px;
  margin: 10px 0;
  text-align: left !important;
  word-wrap: break-word;
}

/* Darker chat container */
.darker {
  border-color: #8500a7;
  background-color: #8500a7;
  color: #ffffff;
  text-align: right !important;
}

/* Clear floats */
.container::after {
  content: "";
  clear: both;
  display: table;
}

/* Style images */
.container img {
  float: left;
  max-width: 60px;
  width: 100%;
  margin-right: 20px;
  border-radius: 50%;
  font-size: 0.8rem;
}

/* Style the right image */
.container img.right {
  float: right;
  margin-left: 20px;
  margin-right:0;
  font-size: 0.8rem;
}

/* Style time text */
.time-left {
  float: left;
  color: #999;
}
.time-right {
  float: right;
  color: #e4e4e4;
}

/* Chat CSS */
.chat_ib h5{ font-size:15px; color:#464646; margin:0 0 8px 0;}
.chat_ib_span{ font-size:12px; float:right;}
.chat_ib p{ font-size:12px; color:#989898; margin:auto}
.chat_img {
  float: left;
  width: 10%;
}
.chat_ib {
  float: left;
  padding: 0 0 0 15px;
  width: 88%;
}

.chat_people{ overflow:hidden; clear:both;}
.chat_list {
  border-bottom: 1px solid #c4c4c4;
  margin: 10px 0px;
  padding: 10px 10px 10px;
}
.inbox_chat { overflow-y: scroll;}

.inbox_item_left {
  border: 0px !important;
  padding: 0rem 1.5rem 0rem 0.5rem !important;
}
.inbox_item_right {
  border: 0px !important;
  padding: 0rem 0.5rem 0rem 1.5rem !important;
}
.attachment {
  min-width: 50px;
  min-height: 50px;
  max-width: 150px;
  max-height: 200px;
  border-radius: 0px !important;
}

.hidden {
  display: none;
}

.text-teal {
  color: #009AB1;
}

.text-teal:hover {
  color: #009AB1;
}

.message-info-modal {
  margin-right: 4px !important;
  max-width: 230px !important;
}

.menu-toggle {
  border: 0 !important;
  padding: 0 !important;
  color: black !important;
}
</style>
